/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { connect, useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import PopupLoader from 'components/common/PopupLoader';
import { addAlert } from 'store/actions/alert/alerts';
import { authPatchRequestWithParam } from 'helpers/apiRequests';
import { Grid, FormHelperText, Container } from '@material-ui/core';
import UserSessionDataHandler from 'auth/UserSessionsDataHandler';
import Map from 'components/common/components/drawMap/Map';
import { editLocalZone } from 'store/actions/map/allZones';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import Icons from 'consts/icons';
import { userStyles } from 'consts/styles/User';
import { formStyles } from 'consts/styles/Form';
import Typography from '@material-ui/core/Typography';
import Tooltip from '@material-ui/core/Tooltip';

import EachSideAdminContentHandler from 'components/user/admin/users/EachSideAdminContentHandler';

import AddZoneForm from '../ZoneDetailsForm';
import {
  borderValues,
  validateCheck,
  validateData,
} from '../../utils/zoneDetailsUtils';
import { AddApprovedUavosForm } from '../components';
import EditActivationForm from './EditActivationForm/EditActivationForm';

const a11yProps = index => ({
  id: `simple-tab-${index}`,
  'aria-controls': `simple-tabpanel-${index}`,
});

const EditZone = props => {
  const { setOpenModal, zoneToEdit, language } = props;

  const dispatch = useDispatch();

  const strings = useSelector(state => state.language);

  const [seeableLoader, setSeeableLoader] = React.useState(false);
  const [geojson, setGeojson] = React.useState(zoneToEdit.geojson);
  const [values, setValues] = React.useState(zoneToEdit);
  const [errors, setErrors] = React.useState({});
  const [tabValue, setTabValue] = React.useState(0);

  const classesUser = userStyles();
  const formClasses = formStyles();

  const closeSubtitles = useSelector(state => state.language).close_;
  const { placeholderForm } = useSelector(state => state.language).areas;

  React.useEffect(() => {
    setValues({ ...zoneToEdit });
    setGeojson(zoneToEdit.geojson);
  }, [zoneToEdit]);

  const save = async () => {
    const data = { ...values };
    data.zone_category = data.zone_category.uid
      ? data.zone_category.uid
      : data.zone_category;
    data.amsl_min = parseInt(data.amsl_min);
    data.amsl_max = parseInt(data.amsl_max);
    data.geojson = geojson.features ? geojson.features[0].geometry : geojson;
    data.name = `${values.type} ${
      UserSessionDataHandler.getUserDataObject().organization
    } ${values.othername}`;
    const dataErrors = validateData(data);
    if (dataErrors) {
      setErrors(dataErrors);
      return;
    }
    setSeeableLoader(true);
    const result = await authPatchRequestWithParam('areas', data.uid, data);
    if (result?.status === 200) {
      dispatch(
        addAlert({
          title: strings.alerts.addDataSuccess.title_,
          desc: strings.alerts.addDataSuccess.desc_,
          type: 'success',
        })
      );
      dispatch(editLocalZone(result.data));
      handleClose();
      setSeeableLoader(false);
    } else {
      dispatch(
        addAlert({
          title: strings.alerts[result?.data?.code]?.title_,
          desc: strings.alerts[result?.data?.code]?.desc_,
          type: 'error',
        })
      );
    }
    setSeeableLoader(false);
  };

  const handleChange = event => {
    const { target } = event;
    const { name, value } = target;
    const ifCheckIsTrue = validateCheck(name, value);

    setValues({
      ...values,
      [name]: value,
    });

    setErrors({ ...errors, [name]: !ifCheckIsTrue });
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  const tabsAction = React.useRef();

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      tabsAction.current.updateIndicator();
    }, 500);

    return () => {
      clearTimeout(timeout);
    };
  }, [tabValue]);
  return (
    <>
      <Grid
        className={`${classesUser.User}__add-component ${classesUser.User}`}
      >
        <Grid
          item
          className={`${formClasses.Form}--flex ${formClasses.Form}--flex--between `}
          xs={12}
        >
          <Grid item xs={2} align="left">
            <Typography
              variant="h3"
              className={`${formClasses.Form}__text-field__subtitle ${formClasses.Form}__text-field`}
            >
              {language.zonesDetails.editZone_}
            </Typography>
          </Grid>
          <Grid item xs={9}>
            <Grid container>
              <Tabs
                value={tabValue}
                onChange={(event, value) => setTabValue(value)}
                aria-label="simple tabs example"
                indicatorColor="primary"
                variant="fullWidth"
                centered
                classes={{
                  root: `${formClasses.Form}__text-field ${formClasses.Form}--width`,
                  indicator: `${formClasses.Form}__tabs__button`,
                }}
                action={tabsAction}
              >
                <Tab
                  label={language.zonesDetails.basicInfo_}
                  {...a11yProps(0)}
                />
                <Tab
                  label={language.zonesDetails.activationsInfo_}
                  {...a11yProps(1)}
                />
                <Tab
                  label={language.zonesDetails.approvedDronesInfo_}
                  {...a11yProps(2)}
                />
                {/* {zoneToEdit.type.startsWith('DRA-P') && (
                  <Tab
                    label={language.zonesDetails.approvedDronesInfo_}
                    {...a11yProps(2)}
                  />
                )} */}
              </Tabs>
            </Grid>
          </Grid>
          <Grid item xs={1} align="right">
            <Tooltip title={closeSubtitles} placement="bottom">
              <div
                onClick={() => handleClose()}
                onKeyPress={() => handleClose()}
                role="button"
                tabIndex={0}
              >
                <div
                  className={`${classesUser.User}__settings__close__container`}
                >
                  <Icons.Actions.Close />
                </div>
              </div>
            </Tooltip>
          </Grid>
        </Grid>
        {seeableLoader && <PopupLoader />}

        <EachSideAdminContentHandler value={tabValue} index={0}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={7}
              className={`${formClasses.Form}__overflow-component`}
            >
              <Map
                setGeojson={setGeojson}
                geojson={geojson}
                drawTypes={['circle', 'polygon']}
                setErrors={setErrors}
                errors={errors}
              />
              <Container component="main">
                <FormHelperText
                  className={`${formClasses.Form}__label ${
                    errors.map
                      ? `${formClasses.Form}__text-field__form-helper--error`
                      : ''
                  }`}
                >
                  {errors.map ? placeholderForm.required : <>&nbsp;</>}
                </FormHelperText>
              </Container>
            </Grid>
            <Grid
              item
              xs={5}
              className={`${formClasses.Form}__overflow-component`}
            >
              <AddZoneForm
                save={save}
                values={values}
                errors={errors}
                handleChange={handleChange}
                borderValues={borderValues}
              />
            </Grid>
          </Grid>
        </EachSideAdminContentHandler>
        <EachSideAdminContentHandler value={tabValue} index={1}>
          <EditActivationForm zoneDetails={values} />
        </EachSideAdminContentHandler>
        <EachSideAdminContentHandler value={tabValue} index={2}>
          <AddApprovedUavosForm zoneUid={zoneToEdit?.uid} addRender={false} />
        </EachSideAdminContentHandler>
      </Grid>
    </>
  );
};

EditZone.propTypes = {
  zoneToEdit: PropTypes.object.isRequired,
  language: PropTypes.object.isRequired,
  setOpenModal: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  language: state.language,
});

export default connect(mapStateToProps)(EditZone);
